import Header from "./Header";
import NavBar from "./NavBar";
import Footer from "./Footer";

export default function PageLayout({ children }) {
  return (
    <>
      <Header />
      <NavBar />
      <main>{children}</main>
      <Footer />
    </>
  );
}
